import { render, staticRenderFns } from "./DespesasFiltros.vue?vue&type=template&id=5238c25f"
import script from "./DespesasFiltros.vue?vue&type=script&lang=js"
export * from "./DespesasFiltros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports